import React from 'react'
import { Card, Row, Col, Image } from 'react-bootstrap'

// Import Image
import image from '../../images/186313.png'

const UserCard = ({ user }) => {
  return (
    <Card className='mb-3'>
      <Card.Body>
        <Row>
          <Col md={3}>
            <Image src={image} fluid />
          </Col>
          <Col md={9}>
            <Card.Title>
              <b>{user.name}</b>
            </Card.Title>
            <p className='text-secondary'>{user.description}</p>
            <p className='mb-0'>
              <b>Skills:</b> {user.skills}
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default UserCard
